import * as t from 'io-ts';
import { ProblemWithErrorCodeCodec } from '../problemApi.types';
import { fromEnum } from '../../responseUtil';

export enum VehicleDepartureErrorCode {
    HAS_OUTGOING = 'has-outgoing',
    INVALID_LOCATION = 'invalid-location',
    NOT_SUPPORTED_TRANSPORT_TYPE = 'not-supported-transport-type',
    FOUND_VEHICLE_IN_INCOMING = 'found-vehicle-in-incoming',
}

export const VehicleDepartureErrorCodec = t.intersection([
    ProblemWithErrorCodeCodec,
    t.type({
        error_code: fromEnum<VehicleDepartureErrorCode>('DepartureErrorCodes', VehicleDepartureErrorCode),
    }),
    t.partial({
        vin: t.string,
    }),
]);

export const FilterMaterializationExceededErrorResponseCodec = t.type({
    status: t.literal(400),
    data: t.type({
        detail: t.string,
        error_code: t.literal('filter-materialization-exceeded'),
    }),
});

export const DuplicateVinErrorResponseCodec = t.type({
    status: t.literal(400),
    data: t.type({
        detail: t.string,
        error_code: t.literal('duplicate-vin'),
    }),
});

export const CompoundVehicleLoadIdConflictProblemCodec = t.intersection([
    ProblemWithErrorCodeCodec,
    t.type({
        error_code: t.literal('load-id-conflict'),
    }),
]);

export type ApiCompoundVehicleLoadIdConflictProblem = t.TypeOf<typeof CompoundVehicleLoadIdConflictProblemCodec>;
